exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.estilo-grilla {\n  width: 100%;\n  height: auto;\n  font-family: 'Asap', sans-serif;\n}\n.ag-theme-material .ag-cell-inline-editing,\n.ag-theme-material .ag-popup-editor {\n  background: #fff !important;\n}\n.ag-theme-material .ag-cell-inline-editing {\n  height: 48px !important;\n}\n", ""]);

// exports
